<div class="container vh-100 vw-100 d-flex flex-column justify-content-center">
  <div class="text-center">
    <p>Authenticating...</p>
  </div>
</div>
